// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36FNr","largestCol":"styles_largestCol__19gCN","smallestCol":"styles_smallestCol__1OhdG"};